<style scoped lang="scss" type="text/scss">
    .group-photo-item-container {
        display: flex;
        flex-direction: column;
        align-items: center;

        .group-photo-image-container {
            width: 100%;
            height: 10.5rem;
        }

        .text-panel {
            flex: 1;
            width: 100%;
            box-sizing: border-box;
            padding: .3rem 1rem .5rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: rgba(0, 0, 0, .85);

            .team-name {
                height: 1.5rem;
                margin-bottom: .3rem;
                line-height: 2rem;
                font-size: 1rem;
                width: 100%;
                text-align: center;
                color: #DDD;
            }

            .school-name {
                height: 1rem;
                line-height: 1rem;
                font-size: .75rem;
                margin-top: .3rem;
                width: 100%;
                text-align: center;
                color: #AAA;
            }

            .manager-name {
                height: 1rem;
                line-height: 1rem;
                font-size: .75rem;
                margin-top: .3rem;
                color: #AAA;
            }
        }
    }
</style>

<template>
    <functional-card class="group-photo-item-container" :class="{'large': false === isNameShort}"
                     :downloadable="true" :editable="false" :removable="false" @call-download="download"
    >
        <normal-image class="group-photo-image-container" :src="groupPhoto"></normal-image>

        <div class="text-panel">
            <div class="team-name global-text-ellipsis" :title="teamName">{{ teamName }}</div>
            <div class="school-name global-text-ellipsis" :title="schoolName">{{ schoolName }}</div>
        </div>
    </functional-card>
</template>

<script>
    import FunctionalCard from '../../../../../components/functional-card/index';
    import NormalImage from '../../../../../components/normal-image/index';
    import _ from 'lodash';

    export default {
        name: '',
        props: {
            info: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        components: {
            NormalImage,
            FunctionalCard
        },
        data () {
            return {};
        },
        computed: {
            imagePlaceholder () {
                return this.$store.state.imagePlaceholder;
            },
            teamName () {
                return _.get(this.info, 'team_name', null);
            },
            schoolName () {
                return _.get(this.info, 'school_name', null);
            },
            groupPhoto () {
                return _.get(this.info, 'group_photo_url', this.imagePlaceholder);
            },
            isNameShort () {
                return this.teamName.length >= 11;
            }
        },
        methods: {
            download (callback) {
                this.$normalRequest('player/downloadGroupPhoto', {
                    id: this.info.id
                }, false, false, this, 'requesting').then(data => {
                    this.$download(data);
                    callback();
                }).catch(_ => {
                    callback();
                });
            }
        }
    };
</script>
